import { render, staticRenderFns } from "./CheckFileIcon.vue?vue&type=template&id=037cdb22&scoped=true&"
import script from "./CheckFileIcon.vue?vue&type=script&lang=js&"
export * from "./CheckFileIcon.vue?vue&type=script&lang=js&"
import style0 from "./CheckFileIcon.vue?vue&type=style&index=0&id=037cdb22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037cdb22",
  null
  
)

export default component.exports